import { render } from "./TooltipsPage.vue?vue&type=template&id=69762e1e&ts=true"
import script from "./TooltipsPage.vue?vue&type=script&lang=ts"
export * from "./TooltipsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__